// extracted by mini-css-extract-plugin
export default {"mainLayout":"MainLayout_mainLayout__aJq7l","page":"MainLayout_page__VIbOB","topFixedSpacer":"MainLayout_topFixedSpacer__oKKl1"};